export default {
  state: {
    textBoxes: [
      {
        text: '',
        stopTime: '',
        arrowPosition: '',
        position: '',
        icon: '',
        ref: ''
      }
    ],
    animationButtons: [],
    showTextBox: false,
    showIcon: false,
    stopTimeIdx: -1,
    showButtons: true,
    introTextBox: undefined,
    painPointTextBox: undefined,
    technologyLandscapeTextBox: undefined,
    benefitCardTextBox: undefined,
    delay: false
  },
  mutations: {
    setDelay(state, payload) {
      state.delay = payload;
    },
    pushTextBoxes(state, payload) {
      state.textBoxes = payload;
    },
    updateShowButtons(state, payload) {
      state.showButtons = payload;
    },
    pushAnimationButtons(state, payload) {
      state.animationButtons = payload;
    },
    updateStopTimeIdx(state, payload) {
      state.stopTimeIdx = payload;
    },

    updateShowTextBox(state, payload) {
      state.showTextBox = payload;
    },
    updateShowIcon(state, payload) {
      state.showIcon = payload;
    },
    clearTextBox(state) {
      state.textBoxes = [];
    },
    setIntroTextbox(state, payload) {
      state.introTextBox = payload;
    },
    setPainPointTextBox(state, payload) {
      state.painPointTextBox = payload;
    },

    setTechnologyLandscapeTextBox(state, payload) {
      state.technologyLandscapeTextBox = payload;
    },
    setBenefitCardTextBox(state, payload) {
      state.benefitCardTextBox = payload;
    }
  },
  actions: {
    getIntroTextBox({ commit, rootState }) {
      let tempObj =
        rootState.moduleMacroAnimations.macroAnimation.stopTimes.intro;
      commit('setIntroTextbox', tempObj);
    },
    getPainPointTextBox({ commit, rootState }) {
      let tempObj =
        rootState.moduleMacroAnimations.macroAnimation.stopTimes.painCard;
      commit('setPainPointTextBox', tempObj);
    },

    getTechnologyLandscapeTextBox({ commit, rootState }) {
      let tempObj =
        rootState.moduleMacroAnimations.macroAnimation.stopTimes
          .technologyLandscape;
      commit('setTechnologyLandscapeTextBox', tempObj);
    },
    getBenefitCardTextBox({ commit, rootState }) {
      let tempObj =
        rootState.moduleMacroAnimations.macroAnimation.stopTimes.benefitCard;
      commit('setBenefitCardTextBox', tempObj);
    },
    generateAnimationTextBoxes({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        let tempArr = [];
        for (let textBox of rootState.moduleMacroAnimations.macroAnimation
          .stopTimes.stopTimes) {
          let tempObj = {
            text: textBox.text,
            stopTime: textBox.stopTime,
            arrowPosition: textBox.arrowPosition,
            position: textBox.position,
            isIndBenefit: textBox.isIndBenefit ? textBox.isIndBenefit : false,
            icon: textBox.icon,
            ref:
              rootState.moduleMacroAnimations.macroAnimation.ref +
              textBox.stopTime
          };
          tempArr.push(tempObj);
        }
        commit('pushTextBoxes', tempArr);
        resolve();
      });
    },
    generateAnimationButtons({ commit, rootState }) {
      let tempArr = [];
      for (let macroAnimation of rootState.macroAnimations) {
        let tempObj = {
          ...macroAnimation.animationButton,
          ref: macroAnimation.ref,
          parentNumId: macroAnimation.numId
        };
        tempArr.push(tempObj);
      }
      commit('pushAnimationButtons', tempArr);
    }
  }
};
